module.exports = __webpack_public_path__ + "media/images/emblems/Cheserex-coat_of_arms-723a832a5c6e81acdb9e9baa3a4165d2.svg";